import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store';
import myApi from './gavnoCode/ApiHandler';
import VueMask from 'v-mask';
import Vue2Filters from 'vue2-filters';
import external from "@/gavnoCode/external";
import './registerServiceWorker';
import myFilter from './gavnoCode/filters'

Vue.prototype.$myApi = myApi;
Vue.config.productionTip = false;
Vue.use(VueMask);
Vue.use(Vue2Filters);
Vue.prototype.$external = external;
Vue.prototype.$myFilter = myFilter;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

